import { render } from "./ListeContactPage.vue?vue&type=template&id=63ad44c4&ts=true"
import script from "./ListeContactPage.vue?vue&type=script&lang=ts"
export * from "./ListeContactPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__